import React, { createContext, useState, useContext } from 'react';
import PropTypes from 'prop-types';

const CartContext = createContext();

export const CartProvider = ({ children }) => {
  const [selectedParticipant, setSelectedParticipant] = useState(null);
  const [participants, setParticipants] = useState([]);
  const [products, setProducts] = useState([]);
  const [cart, setCart] = useState([]);


  const addParticipant = (participant) => {
    setParticipants((prevParticipants) => [...prevParticipants, participant]);
  };

  const removeParticipant = (participant) => {
    setParticipants((prevParticipants) => prevParticipants.filter(p => p.IceNumber !== participant.IceNumber));
  };

  const addProduct = (product) => {
    setProducts((prevProducts) => [...prevProducts, product]);
  };

  const removeProduct = (product) => {
    setProducts((prevProducts) => prevProducts.filter(p => p.ProductId !== product.ProductId));
  };

  const addCart = (cart) => {
    setCart(cart);
  };


  const clearCart = () => {
    setParticipants([]);
    setProducts([]);
    setSelectedParticipant(null);
  }
  const updateParticipantDetails = (productId, participantId, participantDetails) => {
    setProducts((prevProducts) =>
      prevProducts.map((product) =>
        product.ProductId === productId
          ? { ...product, participantDetails }
          : product
      )
    );

    setParticipants((prevParticipants) =>
      prevParticipants.map((participant) =>
      participant.ParticipantId === participantId
        ? { ...participant, ...participantDetails[0] }
        : participant
      )
    );
  };

  return (
    <CartContext.Provider value={{ participants, products, addParticipant, removeParticipant, updateParticipantDetails, addProduct, removeProduct, addCart, cart, clearCart, selectedParticipant, setSelectedParticipant }}>
      {children}
    </CartContext.Provider>
  );
};

const ParticipantPropTypes = PropTypes.shape({
  IceNumber: PropTypes.number.isRequired,
  ParticipantName: PropTypes.string.isRequired,
  PrimaryMedicalCondition: PropTypes.string,
});

const ProductPropTypes = PropTypes.shape({
  ParticipantId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  ProductId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  BandImage: PropTypes.string.isRequired,
  BandType: PropTypes.string.isRequired,
  BandColour: PropTypes.string.isRequired,
  Quantity: PropTypes.number.isRequired,
  Price: PropTypes.number.isRequired,
  ParticipantDetails: PropTypes.arrayOf(ParticipantPropTypes),
});

CartProvider.propTypes = {
  children: PropTypes.node.isRequired,
  participants: PropTypes.arrayOf(ParticipantPropTypes),
  products: PropTypes.arrayOf(ProductPropTypes),
};

export const useCartContext = () => {
  const context = useContext(CartContext);
  if (!context) {
    throw new Error("useCartContext must be used within a CartProvider");
  }
  return context;
};